import classNames from "classnames";
import React from "react";
import styles from "rivals/components/app/Layout/Footer/Footer.module.scss";
import strings from "rivals/components/app/Layout/Footer/strings";
import Link from "rivals/components/shared/Link";
import { PATHS } from "rivals/shared/constants";
import type { Props } from "./types";

const {
  giftLinkText,
  aboutLinkText,
  contactLinkText,
  footerText,
  footerCopyrightText,
  helpLinkText,
  tosLinkText
} = strings;

export default function FooterLinks({
  areArticleLinks = false,
  children,
  giftingEnabled = false
}: Props): React.JSX.Element | null {
  const footerStyles = classNames(styles.footer, {
    [styles.articleFooter]: areArticleLinks
  });

  if (areArticleLinks) {
    return (
      <footer className={footerStyles} data-philter={"article-footer"}>
        <div className={styles.articleLinksContainer}>
          <div className={styles.footerLinks}>
            <Link
              className={styles.articleLinks}
              href={
                process.env.NEXT_PUBLIC_FOOTER_TOS &&
                process.env.NEXT_PUBLIC_FOOTER_TOS !== "null"
                  ? process.env.NEXT_PUBLIC_FOOTER_TOS
                  : "https://www.on3.com/page/terms-of-service/"
              }
              target="_blank"
            >
              {tosLinkText}
            </Link>
            {children}
            {giftingEnabled && (
              <Link href={PATHS.GIFTING} target="_blank">
                {giftLinkText}
              </Link>
            )}
          </div>
        </div>
      </footer>
    );
  }
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLogo} />
      <div className={styles.footerLinks}>
        <Link
          href={
            process.env.NEXT_PUBLIC_FOOTER_ABOUT &&
            process.env.NEXT_PUBLIC_FOOTER_ABOUT !== "null"
              ? process.env.NEXT_PUBLIC_FOOTER_ABOUT
              : "https://www.on3.com/about/"
          }
          target="_blank"
        >
          {aboutLinkText}
        </Link>
        <Link
          href={
            process.env.NEXT_PUBLIC_FOOTER_HELP &&
            process.env.NEXT_PUBLIC_FOOTER_HELP !== "null"
              ? process.env.NEXT_PUBLIC_FOOTER_HELP
              : "https://on3.zendesk.com/hc/en-us"
          }
          target="_blank"
        >
          {helpLinkText}
        </Link>
        <Link
          href={
            process.env.NEXT_PUBLIC_FOOTER_CONTACT_US &&
            process.env.NEXT_PUBLIC_FOOTER_CONTACT_US !== "null"
              ? process.env.NEXT_PUBLIC_FOOTER_CONTACT_US
              : "https://www.on3.com/contact/"
          }
          target="_blank"
        >
          {contactLinkText}
        </Link>
      </div>
      <div className={styles.footerLinks}>
        <Link
          href={
            process.env.NEXT_PUBLIC_FOOTER_TOS &&
            process.env.NEXT_PUBLIC_FOOTER_TOS !== "null"
              ? process.env.NEXT_PUBLIC_FOOTER_TOS
              : "https://www.on3.com/page/terms-of-service/"
          }
          target="_blank"
        >
          {tosLinkText}
        </Link>
      </div>
      <div className={styles.footerLinks}>
        {giftingEnabled && (
          <Link href={PATHS.GIFTING} target="_blank">
            {giftLinkText}
          </Link>
        )}
      </div>
      <div className={styles.footerLinks}>{children}</div>
      <div className={styles.copyrightSection}>
        <div
          className={styles.copyrightNotice}
          data-philter={"react-data-footer"}
        >
          {footerText}
        </div>
        <div
          className={styles.copyrightNotice}
          data-philter={"react-copyright-footer"}
        >
          {footerCopyrightText}
        </div>
      </div>
    </footer>
  );
}
